import React from 'react';
import { useRouteParams } from '@/context/routeParamsContext';
import LoungeDetailsPage from './LoungeDetailsPage';

const LoungeDetailsRoute = () => {
  const { airportCode, loungeId, product } = useRouteParams();
  const routeKey = `${product}/${airportCode}/${loungeId}`;

  // Fetchye keeps the selected Redux cache entry in hook-local state. Remount
  // the data boundary so a route change cannot render from the prior entry.
  return <LoungeDetailsPage key={routeKey} />;
};

export default LoungeDetailsRoute;
